export const SEARCH_INPUT_LENGTH = 100
